"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIconBase = _interopRequireDefault(require("react-icon-base"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CategoryCodeGMB = function CategoryCodeGMB(props) {
  return _react.default.createElement(_reactIconBase.default, _extends({
    viewBox: "0 0 16 16"
  }, props), _react.default.createElement("g", null, _react.default.createElement("title", null, "CategoryCodeGMB"), _react.default.createElement("g", null, _react.default.createElement("path", {
    d: "M13.079,2.125H7.491a.8.8,0,0,0-.8.8V5.389h3.917V9.306h2.468a.8.8,0,0,0,.8-.8V2.921A.8.8,0,0,0,13.079,2.125Zm-4.792,2.4a.8.8,0,1,1,.8-.8A.8.8,0,0,1,8.287,4.521Zm3.995,3.988a.8.8,0,1,1,.8-.8A.8.8,0,0,1,12.282,8.509Zm0-3.988a.8.8,0,1,1,.8-.8A.8.8,0,0,1,12.282,4.521Z"
  }), _react.default.createElement("path", {
    d: "M8.509,6.694H2.921a.8.8,0,0,0-.8.8v5.588a.8.8,0,0,0,.8.8H8.509a.8.8,0,0,0,.8-.8V7.491A.8.8,0,0,0,8.509,6.694ZM3.718,9.084a.8.8,0,1,1,.8-.8A.794.794,0,0,1,3.718,9.084Zm2,2a.8.8,0,1,1,.8-.8A.8.8,0,0,1,5.715,11.081Zm1.991,1.991a.8.8,0,0,1,0-1.593h.007a.8.8,0,0,1-.007,1.593Z"
  }))));
};

var _default = CategoryCodeGMB;
exports.default = _default;